import { render } from "./svg-icon.vue?vue&type=template&id=b740205a&scoped=true&ts=true"
import script from "./svg-icon.vue?vue&type=script&lang=ts"
export * from "./svg-icon.vue?vue&type=script&lang=ts"

import "./svg-icon.vue?vue&type=style&index=0&id=b740205a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b740205a"]])

export default __exports__